import { lazy } from "react"
import { Navigate } from "react-router-dom"
import { energyPassportRoutes } from "@/features/energy-passport/routes.tsx"
import AuditorEnergyAuditAnnouncements from "@/pages/dashboard/energy-audit/announcements"
import { AUDITOR_BASE_ROLES_VALUES } from "@/shared/constants"
import type { CustomRoute } from "@/shared/types"
import ErrorPage from "@/shared/ui/error-page.tsx"

const AuditorEnergyAuditAnnouncementDetailPage = lazy(
  async () => await import("@/pages/dashboard/energy-audit/announcements/announcement-detail-page.tsx")
)
const ProtocolActionEnergyAuditDetail = lazy(
  async () => await import("@/pages/dashboard/company-energy-audit/current/ui/energy-audit-detail/protocol-actions")
)
const AuditorEnergyAuditAnnouncementView = lazy(async () => await import("@/pages/dashboard/energy-audit/announcements/View"))
const AuditorEnergyAuditCurrent = lazy(async () => await import("@/pages/dashboard/energy-audit/current"))
const AuditorEnergyAuditCurrentView = lazy(async () => await import("@/pages/dashboard/energy-audit/current/View"))
const AuditorEnergyAuditCurrentEnergyAccounting = lazy(async () => await import("@/pages/dashboard/energy-audit/current/energy-accounting"))
const AuditorEnergyAuditCurrentEnergyBalance = lazy(async () => await import("@/pages/dashboard/energy-audit/current/energy-balance"))
const AuditorEnergyAuditCurrentComparativeDynamics = lazy(async () => await import("@/pages/dashboard/energy-audit/current/energy-accounting"))
const AuditorEnergyAuditCurrentOtmPlan = lazy(async () => await import("@/pages/dashboard/energy-audit/current/otm-plan"))
const AuditorEnergyAuditCompleted = lazy(async () => await import("@/pages/dashboard/energy-audit/completed"))
const AuditorEnergyAuditCommentForReport = lazy(async () => await import("@/pages/dashboard/energy-audit/current/AuditorEnergyAuditCommentForReport"))
// const AuditorEnergyAuditCurrentProgram = lazy(async () => await import("@/features/audit-program/ui"))
const AuditorEnergyAuditCurrentProgram = lazy(async () => await import("@/features/audit-program/ui/auditor-program-page.tsx"))
const AuditorEnergyAuditCurrentProgramHistory = lazy(async () => await import("@/features/audit-program/ui/program-history-page.tsx"))

export const auditorEnergyAuditRoutes: CustomRoute = {
  path: "energy-audit",
  handle: {
    label: "Энергоаудит",
    i18Key: "energy-audit",
    icon: "ChartBubble",
    ignoreChildren: true,
    allowedRoles: AUDITOR_BASE_ROLES_VALUES
  },
  errorElement: <ErrorPage />,
  children: [
    {
      index: true,
      element: <Navigate to="announcements" replace />
    },
    {
      handle: { label: "Объявления", i18Key: "announcement" },
      path: "announcements",
      children: [
        {
          index: true,
          Component: AuditorEnergyAuditAnnouncements
        },
        {
          path: "detail/:requestId",
          handle: { i18Key: "moreDetails" },
          Component: AuditorEnergyAuditAnnouncementDetailPage
        },
        {
          path: "view/:energy_audit_announcement_id",
          handle: { label: "Просмотреть", i18Key: "energy-audit__announcement__view" },
          Component: AuditorEnergyAuditAnnouncementView
        }
      ]
    },
    {
      path: "current",
      handle: { label: "Текущие", i18Key: "current" },
      children: [
        {
          index: true,
          Component: AuditorEnergyAuditCurrent
        },
        {
          path: ":contractId/",
          handle: {
            label: "Подробнее",
            i18Key: "moreDetails",
            keepSearchParams: ["requestId"]
          },
          children: [
            {
              index: true,
              Component: AuditorEnergyAuditCurrentView
            },
            {
              path: "program",
              handle: { label: "Program", i18Key: "makeNewProgram" },
              Component: AuditorEnergyAuditCurrentProgram
            },
            {
              path: "program-history",
              handle: { label: "Program", i18Key: "makeNewProgram" },
              Component: AuditorEnergyAuditCurrentProgramHistory
            },
            {
              path: "otm",
              handle: { label: "otm", i18Key: "otm" },
              Component: AuditorEnergyAuditCurrentOtmPlan
            },
            {
              path: "comment",
              handle: { label: "Comment", i18Key: "report_comment" },
              Component: AuditorEnergyAuditCommentForReport
            },
            {
              path: "protocol-action",
              handle: { label: "Comment", i18Key: "protocol-action" },
              Component: ProtocolActionEnergyAuditDetail
            },
            energyPassportRoutes
          ]
        },
        {
          path: "view/:energy_audit_view_id/:energy_audit_view_step",
          handle: { label: "Подробнее", i18Key: "energy-audit__current__more" },
          Component: AuditorEnergyAuditCurrentView
        },
        {
          path: ":energy_audit_current_id/energy-accounting",
          handle: { label: "Объявления", i18Key: "energy-audit__current__energy-accounting" },
          Component: AuditorEnergyAuditCurrentEnergyAccounting
        },
        {
          path: ":energy_audit_current_id/energy-balance",
          handle: { label: "Объявления", i18Key: "energy-audit__current__energy-balance" },
          Component: AuditorEnergyAuditCurrentEnergyBalance
        },
        {
          path: ":energy_audit_current_id/comparative-dynamics",
          handle: { label: "Объявления", i18Key: "energy-audit__current__comparative-dynamics" },
          Component: AuditorEnergyAuditCurrentComparativeDynamics
        },
        {
          path: ":energy_audit_current_id/otm-plan",
          handle: { label: "Объявления", i18Key: "energy-audit__current__otm-plan" },
          Component: AuditorEnergyAuditCurrentOtmPlan
        }
      ]
    },
    {
      path: "completed",
      handle: { label: "Завершенные", i18Key: "energy-audit__completed" },
      Component: AuditorEnergyAuditCompleted
    }
  ]
}
